// extracted by mini-css-extract-plugin
module.exports = {"content":"styles_content__1iG5W","header":"styles_header__1rknh","modal_header":"styles_modal_header__37LXf","new_project_body":"styles_new_project_body__2B3mg"};